import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import EnterpriseIcon, { ChevronUpIcon, ChevronDownIcon } from '@enterprise-ui/icons';
import classnames from 'classnames';
import React__default, { useState, useEffect } from 'react';

var SortableHeader = function SortableHeader(_ref) {
  var activeSortColumn = _ref.activeSortColumn,
    children = _ref.children,
    columnClasses = _ref.columnClasses,
    columnField = _ref.columnField,
    columnSort = _ref.columnSort,
    columnText = _ref.columnText,
    dataTestId = _ref.dataTestId,
    onColumnSort = _ref.onColumnSort,
    setActiveSortColumn = _ref.setActiveSortColumn,
    style = _ref.style;
  var sortDirection = columnSort.sortDirection,
    sortType = columnSort.sortType,
    onSort = columnSort.onSort;
  var isCurrentSortColumn = activeSortColumn === columnField;
  var _useState = useState(sortDirection),
    _useState2 = _slicedToArray(_useState, 2),
    sort = _useState2[0],
    setSort = _useState2[1];

  //run sort for default direction
  useEffect(function () {
    var defaultSort = function defaultSort() {
      setActiveSortColumn(columnField);
      if (sort === 'asc') {
        onSort ? onSort('asc', columnField) : onColumnSort(columnField, 'asc', sortType);
      } else if (sort === 'dsc') {
        onSort ? onSort('dsc', columnField) : onColumnSort(columnField, 'dsc', sortType);
      }
    };
    sortDirection && defaultSort();
    //this should only run on initial render which is why we use an empty dependency array
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  var sortIconClasses = classnames('C-TableSortButton__icon', {
    '--sorted': isCurrentSortColumn && sort
  });
  var handleToggleSort = function handleToggleSort() {
    setActiveSortColumn(columnField);
    if (sort === 'asc') {
      setSort('dsc');
      onSort ? onSort('dsc', columnField) : onColumnSort(columnField, 'dsc', sortType);
    } else if (sort === 'dsc') {
      setSort(null);
      onSort ? onSort(null, columnField) : onColumnSort(columnField, null);
    } else if (!sort) {
      setSort('asc');
      onSort ? onSort('asc', columnField) : onColumnSort(columnField, 'asc', sortType);
    }
  };
  var isCenterAligned = columnClasses.includes('--text-align-center');
  var isRightAligned = columnClasses.includes('--text-align-right');
  var sortButtonContentClasses = classnames('C-TableSortButton__content', {
    '--text-align-center': isCenterAligned,
    '--text-align-left': !(isCenterAligned | isRightAligned),
    '--text-align-right': isRightAligned
  });
  var accessibilityText = function accessibilityText() {
    if (sort === 'asc') {
      if (isCurrentSortColumn) {
        return "".concat(columnText, ": sorted ascending, click to sort descending");
      } else {
        return "".concat(columnText, ": unsorted column, click to sort descending");
      }
    } else if (sort === 'dsc') {
      if (isCurrentSortColumn) {
        return "".concat(columnText, ": sorted descending, click to remove sort");
      } else {
        return "".concat(columnText, ": unsorted column, click to remove sort");
      }
    } else {
      return "".concat(columnText, ": unsorted column, click to sort ascending");
    }
  };
  return /*#__PURE__*/React__default.createElement("div", {
    //header is a div not a th to allow more flexible styling
    //including making these buttons fill the cell
    key: "headerButton-".concat(columnField),
    className: columnClasses,
    scope: "col",
    role: "columnheader",
    style: style
  }, /*#__PURE__*/React__default.createElement("button", {
    "aria-label": accessibilityText(),
    "aria-live": "polite",
    "data-testid": dataTestId ? "".concat(dataTestId, "-header-").concat(columnField) : null,
    onClick: handleToggleSort,
    className: "C-TableSortButton C-HeaderCell__cellOverflow"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: sortButtonContentClasses
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "C-HeaderCell__text"
  }, columnText), /*#__PURE__*/React__default.createElement(EnterpriseIcon, {
    icon: sort === 'asc' ? ChevronUpIcon : ChevronDownIcon,
    className: sortIconClasses
  }))), children);
};

export { SortableHeader, SortableHeader as default };
